import React from 'react'
import { Category } from 'iconsax-react'
import { useAppSelector } from '@SonarCX/hooks/redux'

import CommonButton from '../CommonButton'
import Dropdown from '@SonarCX/components/atoms/Dropdown'

import { selectCategory } from '@SonarCX/slices/category'
import { useTaskSWRMutateCache } from '@SonarCX/providers/TaskSWRMutateCache'
import useTaskMultiEdit from '../hooks/useTaskMultiEdit'
import useStyles from '../commonStyles'

const SetCategory: React.FC = () => {
  const { categoriesValues: categories } = useAppSelector(selectCategory)

  const { updateCategories } = useTaskSWRMutateCache()
  const { selected, patchTasks } = useTaskMultiEdit()

  const [value, setValue] = React.useState(null)

  const classes = useStyles()

  const handleClose = React.useCallback(() => {
    setValue(null)
  }, [])

  const handleAccept = React.useCallback(async () => {
    const updates: TaskPatch[] = selected.map(id => ({
      id,
      category_id: value
    }))
    await patchTasks({ updates, message: 'Category updated' })
    updateCategories()
    handleClose()
  }, [selected, value, patchTasks, updateCategories, handleClose])

  return (
    <CommonButton
      title='Set category'
      Icon={Category}
      onAccept={handleAccept}
      onClose={handleClose}
    >
      <div className={classes.content}>
        <div className={classes.title}>Category</div>

        <Dropdown
          options={categories.map(({ id }) => id)}
          renderOption={id => {
            const opt = categories.find(category => category.id === id)

            if (!opt) {
              return null
            }

            return <div key={opt.id}>{opt.name}</div>
          }}
          selected={value}
          onSelect={id => setValue(id)}
          hideAdd
          duplicates
          disablePortal
        >
          <div data-testid='task-category'>
            {categories.find(({ id }) => id === value)?.name || 'Unassigned'}
          </div>
        </Dropdown>
      </div>
    </CommonButton>
  )
}

export default SetCategory
